<script>
  import options from './OnlineDonationQRPrintPageContent.options'
  export default options
</script>

<template>
  <article class="kb-online-donation-qr-print-page-content">

    <div class="kb-online-donation-qr-print-page-content__wrapper">

      <header class="kb-online-donation-qr-print-page-content__header">    
        <div class="kb-online-donation-qr-print-page-content__logo" v-html="svgLogo"></div>
      </header>

      <div class="kb-online-donation-qr-print-page-content__container">

        <h1 class="kb-online-donation-qr-print-page-content__title"> {{ getLabel("title") + ' ' + title}} </h1>

        <div class="kb-online-donation-qr-print-page-content__QR-box-wrapper">

          <div class="kb-online-donation-qr-print-page-content__QR-box">

            <div class="kb-online-donation-qr-print-page-content__QR-img">
              <img :src="`data:image/png;base64, ${qrImgUrlBase}`" :alt='getLabel("qrCodeImgAlt")' />
            </div>

            <template v-if="mobilePayCommentCode || mobilePayNumberCode">
              <ul class="kb-online-donation-qr-print-page-content__QR-details-list">
                <template v-if="mobilePayCommentCode">
                  <li class="kb-online-donation-qr-print-page-content__QR-details-list-detail">
                      {{ getLabel("mobilePayCommentText") }}
                      <span class="kb-online-donation-qr-print-page-content__QR-details-list-detail-span">
                        {{ mobilePayCommentCode }}
                      </span>
                  </li>
                </template>
                <template v-if="mobilePayNumberCode">
                  <li class="kb-online-donation-qr-print-page-content__QR-details-list-detail">
                      {{ getLabel("mobilePayNumberText") }}
                      <span class="kb-online-donation-qr-print-page-content__QR-details-list-detail-span">
                        {{ mobilePayNumberCode }}
                      </span>
                  </li>
                </template>
              </ul>
            </template>

          </div>   

        </div>   
        
        <p class="kb-online-donation-qr-print-page-content__thanks-text">{{getLabel("thanksText")}}</p>

      </div>
  

    </div>

  </article>
</template>
